import { EvaluationColor } from '@repo/types';
import c from 'classnames';
import styles from './RangeSegment.module.css';
import { calculateLeft, PreparedRange } from './utils';

type Props = {
  range: PreparedRange;
  showValue: boolean;
  valueDisplay?: string;
  valueMarkerColor: EvaluationColor;
  isFirst: boolean;
  isLast: boolean;
};

export default function RangeSegment({
  range,
  showValue,
  valueDisplay,
  valueMarkerColor,
  isFirst,
  isLast,
}: Props) {
  const { breakpointLabel, isSampleRange, samplePosition } = range;
  const markerStyle = { left: calculateLeft(isFirst, isLast, samplePosition) };

  return (
    <div
      className={styles.barBlock}
      style={{ flexBasis: `${range.percentage}%` }}
    >
      <div>
        <div
          className={c(
            styles.bar,
            isFirst && styles.first,
            isLast && styles.last,
          )}
        >
          {isSampleRange && showValue && (
            <>
              {valueDisplay && (
                <span
                  className={c(
                    styles.valueAboveMarker,
                    styles[valueMarkerColor],
                  )}
                  style={markerStyle}
                >
                  {valueDisplay}
                </span>
              )}
              <span
                className={styles.triangleMarker}
                style={{ left: `${samplePosition}%` }}
              />
            </>
          )}
        </div>
      </div>
      <div className={c(styles.details, 'flexStart', 'mb-auto')}>
        {breakpointLabel && (
          <span className={c(styles.breakpoint, 'mt-auto')}>
            {breakpointLabel}
          </span>
        )}
      </div>
      {!isLast ? <span className={styles.divider} /> : null}
    </div>
  );
}
